export default {
  en: {
    cookies: {
      enableAll:"Enable all",
      rejectOptional:"Reject optional",
      returnHome:"Return home",
      stripe_label:"{0} - for secure payment processing.",
      stripe_link:"Stripe",
      zendesk_label:"{0} - for integrated technical support and chat. Disabling functional cookies will reduce this functionality.",
      zendesk_link:"Zendesk",
      google_label:"{0} - to help us monitor the web site to understand how to improve user experiences.",
      google_link:"Google Analytics",
      strictlyNecessary: {
        label: "Strictly necessary cookies",
        description: "These cookies are essential so that you can move around the website and use its features. These include sessions for synchronizing authentication between cluster nodes. Without these cookies, services you requested may not function correctly."
      },
      functional: {
        label: "Functional cookies",
        description: "These cookies allow the website to remember choices you make to give you better functionality and personalization."
      },
      performance: {
        label: "Performance cookies",
        description: "These cookies collect information about how you use our website, like which pages you visited, and help us improve its performance."
      },
      ads: {
        label: "Advertising cookies",
        description: "Allow our advertising partners to track any adverts that we may show on our pages to provide a personalized advertising experience for you."
      },
      thirdparty: {
        label: "3rd party cookies",
        description: "We use select 3rd parties to provide functionality and analysis within our site:"
      }
    }
  },
  de: {
    cookies: {
      enableAll:"Alle akzeptieren",
      rejectOptional:"Optionale ablehnen",
      returnHome:"Zurück zur Startseite",
      stripe_label:"{0} - für sichere Zahlungsabwicklung.",
      stripe_link:"Stripe",
      zendesk_label:"{0} - für integrierten technischen Support und Chat. Das Deaktivieren funktionaler Cookies reduziert diese Funktionalität.",
      zendesk_link:"Zendesk",
      google_label:"{0} - hilft uns, die Website zu überwachen und die Benutzererfahrung zu verbessern.",
      google_link:"Google Analytics",
      strictlyNecessary: {
        label: "Unbedingt erforderliche Cookies",
        description: "Diese Cookies sind notwendig, damit Sie sich auf der Website bewegen und deren Funktionen nutzen können. Dazu gehören Sitzungen zur Synchronisierung der Authentifizierung zwischen Clusterknoten. Ohne diese Cookies funktionieren die von Ihnen angeforderten Dienste möglicherweise nicht ordnungsgemäß."
      },
      functional: {
        label: "Funktionale Cookies",
        description: "Diese Cookies ermöglichen es der Website, sich an Ihre Entscheidungen zu erinnern, um Ihnen bessere Funktionalität und Personalisierung zu bieten."
      },
      performance: {
        label: "Leistungs-Cookies",
        description: "Diese Cookies sammeln Informationen darüber, wie Sie unsere Website nutzen, welche Seiten Sie besucht haben, und helfen uns, deren Leistung zu verbessern."
      },
      ads: {
        label: "Werbe-Cookies",
        description: "Erlauben unseren Werbepartnern, Anzeigen auf unseren Seiten zu verfolgen, um Ihnen eine personalisierte Werbeerfahrung zu bieten."
      },
      thirdparty: {
        label: "Drittanbieter-Cookies",
        description: "Wir nutzen ausgewählte Drittanbieter, um Funktionalität und Analysen innerhalb unserer Website bereitzustellen:"
      }
    }
  },
  fr: {
    cookies: {
      strictlyNecessary: {
        label: "Cookies strictement nécessaires",
        description: "Ces cookies sont essentiels pour vous permettre de naviguer sur le site Web et d'utiliser ses fonctionnalités. Cela inclut les sessions pour synchroniser l'authentification entre les nœuds du cluster. Sans ces cookies, les services que vous avez demandés peuvent ne pas fonctionner correctement."
      },
      functional: {
        label: "Cookies fonctionnels",
        description: "Ces cookies permettent au site Web de se souvenir des choix que vous faites pour offrir une meilleure fonctionnalité et personnalisation."
      },
      performance: {
        label: "Cookies de performance",
        description: "Ces cookies collectent des informations sur la façon dont vous utilisez notre site Web, comme les pages que vous avez visitées, et nous aident à améliorer ses performances."
      }
    }
  },
  es: {
    cookies: {
      strictlyNecessary: {
        label: "Cookies estrictamente necesarios",
        description: "Estas cookies son esenciales para que pueda navegar por el sitio web y utilizar sus funciones. Esto incluye sesiones para sincronizar la autenticación entre nodos del clúster. Sin estas cookies, los servicios que solicitó pueden no funcionar correctamente."
      },
      functional: {
        label: "Cookies funcionales",
        description: "Estas cookies permiten que el sitio web recuerde las opciones que realiza para brindarle una mejor funcionalidad y personalización."
      },
      performance: {
        label: "Cookies de rendimiento",
        description: "Estas cookies recopilan información sobre cómo utiliza nuestro sitio web, como las páginas que visitó, y nos ayudan a mejorar su rendimiento."
      }
    }
  }
};
